<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M13.61 6.33A2 2 0 0012 5.52h-2v-1.3A1.93 1.93 0 008.49 2a2.09 2.09 0 00-2.06.81l-2.3 4.71H3a1 1 0 00-1 1.16l.71 4.5a1 1 0 001 .84h6.89a2 2 0 001.91-1.41l1.4-4.5a2 2 0 00-.3-1.78zM8.08 4zm2.52 8H5.91V8.42L8 4.17v3.35h4z"/></svg>